import React, { Fragment } from 'react'
import { Pill } from '@myxplor/ui'
import { FormDisplayErrors } from '@myxplor/forms'
import { isMyChildVacanciesFeatureEnabled } from '../actions/update-myChild'

export const MyChildStatus = ({ status }) => {
  if (!status || !isMyChildVacanciesFeatureEnabled()) {
    return null
  }

  const { submitted, description } = status

  return (
    <Fragment>
      <Pill error={!submitted} ok={submitted}>
        MyChild
      </Pill>

      <div className="enrolmentMessage--wrapper">
        {submitted ? description : <FormDisplayErrors errors={description} />}
      </div>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/gov-registrations/details/ccs-registrations/views/mychild-status.jsx